module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "duty-schedule text-dark"
  }, [_c('transition', {
    attrs: {
      "name": "fadeOut"
    }
  }, [(_vm.isInitialLoading) ? _c('DoSplash') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "do-wrapper"
  }, [_c('WeekSelecter', {
    attrs: {
      "date": _vm.date,
      "startDate": _vm.schoolYear.employee_time_start,
      "endDate": _vm.schoolYear.employee_time_end
    },
    on: {
      "changed": function($event) {
        return _vm.setDate($event)
      }
    }
  }), _vm._v(" "), _c('DutySchedulePlan', {
    attrs: {
      "theCreateEventObj": _vm.theCreateEventObj,
      "usersCalIdsHash": _vm.allUsersInCalIdHash,
      "calendars": _vm.kindergartenCalendars,
      "isEventsLoading": _vm.isEventsLoading,
      "date": _vm.date,
      "events": _vm.events,
      "eventsInHash": _vm.eventsInUserCalendarIdHash,
      "userNorms": _vm.userNorms,
      "theNewlyCreatedSubject": _vm.theNewlyCreatedSubject,
      "schoolSettings": _vm.schoolSettings,
      "isCreateOpeningHours": _vm.isCreateOpeningHours,
      "openingHours": _vm.openingHours
    },
    on: {
      "createSubject": _vm.onCreateSubject,
      "createEvent": _vm.onCreateEvent,
      "editEvent": _vm.onEditEvent,
      "setIsCreateOpeningHours": _vm.setIsCreateOpeningHours,
      "today": _vm.setToday,
      "next": _vm.setNext,
      "prev": _vm.setPrev
    }
  }), _vm._v(" "), (_vm.theCreateEventObj) ? _c('CreateEvent', {
    attrs: {
      "openingHours": _vm.openingHours,
      "user": _vm.theCreateEventObj.user,
      "initDate": _vm.theCreateEventObj.date,
      "initSubject": _vm.theCreateEventObj.subject,
      "emitEvent": true
    },
    on: {
      "addANewEvent": _vm.onAddedEvent,
      "close": _vm.onCloseCreateEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theEditEventObj) ? _c('CreateEvent', {
    attrs: {
      "user": _vm.theEditEventObj.user,
      "editEvent": _vm.theEditEventObj.event,
      "emitEvent": true,
      "openingHours": _vm.openingHours
    },
    on: {
      "updatedEvent": _vm.onUpdatedEvent,
      "deletedEvent": _vm.onDeletedEvent,
      "close": _vm.onCloseCreateEvent
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubjectCalendar) ? _c('CreateSubject', {
    attrs: {
      "calendarAndUsers": _vm.theCreateSubjectCalendar,
      "schoolId": _vm.schoolId,
      "schoolYearId": _vm.schoolYearId
    },
    on: {
      "created": _vm.onNewSubjectCreated,
      "close": function($event) {
        return _vm.onCreateSubject(null)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCreateOpeningHours) ? _c('DutyScheduleOpeningHours', {
    attrs: {
      "propOpeningHours": _vm.openingHours
    },
    on: {
      "close": function($event) {
        return _vm.setIsCreateOpeningHours(false)
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a4468b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutySchedule.vue
// module id = 1449
// module chunks = 1